define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "styled-components", "prop-types", "../NavList", "../../themes"], function (_exports, _taggedTemplateLiteralLoose2, _styledComponents, _propTypes, _NavList, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.NavigationLink = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var _templateObject, _templateObject2;

  var NavigationLink = _styledComponents.default.a.withConfig({
    displayName: "NavigationLink",
    componentId: "sc-1djtruh-0"
  })(["color:", ";cursor:pointer;display:inline-block;font-size:1.5em;line-height:24px;text-align:center;text-decoration:none;transition:font-weight 0.2s ", ";", " &{padding:8px 16px;}", " ", " ", " &::after{content:attr(title);display:", ";font-weight:", ";height:0;overflow:hidden;visibility:hidden;}&:hover{font-weight:", ";color:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.dark;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.easing.ease;
  }, _NavList.NavList, _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    color: ", ";\n\n    ", " & {\n      padding: 0;\n    }\n  "])), function (_ref3) {
    var theme = _ref3.theme,
        sublink = _ref3.sublink;
    return sublink ? theme.colors.dark : theme.colors.white;
  }, _NavList.NavList), function (_ref4) {
    var theme = _ref4.theme,
        icon = _ref4.icon,
        active = _ref4.active;
    return icon && (0, _styledComponents.css)(["padding:8px 20px 8px 16px;position:relative;", " box-icon{fill:", ";height:16px;position:absolute;right:0;top:11px;width:16px;transition:transform 0.2s ", ";", ";}", ""], active === 'true' && (0, _styledComponents.css)(["font-weight:", ";"], theme.font.bold), theme.colors.dark, theme.easing.ease, active === 'true' && (0, _styledComponents.css)(["transform:translate3d(0,5px,0) rotate(180deg);transform-origin:50% 50%;"]), _themes.device.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n        ", " & {\n          padding: 0 20px 0 0;\n        }\n\n        box-icon {\n          fill: ", ";\n          top: 3px;\n        }\n      "])), _NavList.NavList, function (_ref5) {
      var theme = _ref5.theme;
      return theme.colors.white;
    }));
  }, function (_ref6) {
    var sublink = _ref6.sublink;
    return sublink && (0, _styledComponents.css)(["text-align:left;width:100%;&:hover{+ ul{display:block;}}box-icon{fill:", ";height:16px;position:absolute;right:0;top:3px;width:16px;}"], function (_ref7) {
      var theme = _ref7.theme;
      return theme.colors.white;
    });
  }, function (_ref8) {
    var sublink = _ref8.sublink;
    return sublink ? 'none' : 'block';
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.font.bold;
  }, function (_ref10) {
    var theme = _ref10.theme,
        sublink = _ref10.sublink;
    return !sublink && theme.font.bold;
  }, function (_ref11) {
    var theme = _ref11.theme,
        sublink = _ref11.sublink;
    return sublink && theme.colors.primary;
  });

  _exports.NavigationLink = NavigationLink;
  NavigationLink.propTypes = {
    sublink: _propTypes.string,
    icon: _propTypes.string
  };
});